export interface ThemePreset {
  name: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  textColor: string;
  backgroundColor: string;
}

export const THEME_PRESETS: Record<string, ThemePreset> = {
  'ocean-pro': {
    name: 'Ocean Pro',
    primaryColor: '#0B4778',
    secondaryColor: '#2563EB',
    accentColor: '#E0EDFF',
    textColor: '#111827',
    backgroundColor: '#F5F7FB'
  },
  'rose-studio': {
    name: 'Rose Studio',
    primaryColor: '#E11D48',
    secondaryColor: '#9F1239',
    accentColor: '#FCE7F3',
    textColor: '#111827',
    backgroundColor: '#FFF1F2'
  },
  'emerald-calm': {
    name: 'Emerald Calm',
    primaryColor: '#047857',
    secondaryColor: '#065F46',
    accentColor: '#D1FAE5',
    textColor: '#111827',
    backgroundColor: '#F0FDF4'
  },
  'royal-plum': {
    name: 'Royal Plum',
    primaryColor: '#6D28D9',
    secondaryColor: '#4C1D95',
    accentColor: '#EDE9FE',
    textColor: '#111827',
    backgroundColor: '#FAF5FF'
  },
  'sunset-coral': {
    name: 'Sunset Coral',
    primaryColor: '#F97316',
    secondaryColor: '#EA580C',
    accentColor: '#FFEDD5',
    textColor: '#111827',
    backgroundColor: '#FFF7ED'
  },
  'slate-modern': {
    name: 'Slate Modern',
    primaryColor: '#0F172A',
    secondaryColor: '#334155',
    accentColor: '#E2E8F0',
    textColor: '#111827',
    backgroundColor: '#F8FAFC'
  }
};

export const getThemePreset = (presetKey: string): ThemePreset | null => {
  return THEME_PRESETS[presetKey] || null;
};

export const getThemePresetKeys = (): string[] => {
  return Object.keys(THEME_PRESETS);
};

export const getThemePresetList = (): ThemePreset[] => {
  return Object.values(THEME_PRESETS);
};

export const detectThemePreset = (colors: {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  textColor: string;
  backgroundColor: string;
}): string | null => {
  // Normalize colors to uppercase for comparison
  const normalizeColor = (color: string) => color.toUpperCase().trim();
  
  const normalizedPrimary = normalizeColor(colors.primaryColor);
  const normalizedSecondary = normalizeColor(colors.secondaryColor);
  const normalizedAccent = normalizeColor(colors.accentColor);
  const normalizedText = normalizeColor(colors.textColor);
  const normalizedBackground = normalizeColor(colors.backgroundColor);
  
  // Find matching preset
  for (const [key, preset] of Object.entries(THEME_PRESETS)) {
    if (
      normalizeColor(preset.primaryColor) === normalizedPrimary &&
      normalizeColor(preset.secondaryColor) === normalizedSecondary &&
      normalizeColor(preset.accentColor) === normalizedAccent &&
      normalizeColor(preset.textColor) === normalizedText &&
      normalizeColor(preset.backgroundColor) === normalizedBackground
    ) {
      return key;
    }
  }
  
  return null;
};

